import { Map } from 'immutable';
import hiringConfirmationActions, { JobFeedbackAnswer } from 'redux/hiringConfirmation/actions';
import teamActions from 'redux/team/actions';
import { ReduxAction } from 'types/redux.types';
import projectsActions from './actions';

const initState = Map<any>({
  projects: [],
  searchParams: Map({
    string: '',
    sortDirection: 'desc',
    sortField: '',
  }),
  folderTarget: null,
  settingsTarget: null,
  applicationStatusTarget: null,
});

export default function projectReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case projectsActions.SET_SEARCH_PARAMS:
      return state.set('searchParams', action.payload);

    case projectsActions.UPDATE_PROJECTS_LIST: {
      const newState = state.set('projects', action.payload.projects);
      return newState;
    }

    case projectsActions.REFRESH_PROJECTS_LIST_DONE: {
      return state.set(
        'projects',
        state.get('projects').map((project: any) => {
          if (project.id === action.payload.id) {
            return action.payload;
          }
          return project;
        })
      );
    }

    case projectsActions.RENAME_PROJECT: {
      return state.set(
        'projects',
        state.get('projects').map((project: any) => {
          if (project.id === action.payload.id) {
            return { ...project, name: action.payload.name };
          }
          return project;
        })
      );
    }

    case projectsActions.DELETE_PROJECT: {
      return state.set(
        'projects',
        state.get('projects').filter((project: any) => project.id !== action.payload.id)
      );
    }

    case projectsActions.CHANGE_FOLDER: {
      const { fromProject, toProject, newProject } = action.payload;
      let projects = state.get('projects');

      if (newProject) {
        projects = [newProject, ...projects];
      }

      if (toProject && !newProject) {
        projects = projects.map((project: any) => {
          if (project.id === toProject.id) {
            return toProject;
          }
          return project;
        });
      }

      if (fromProject) {
        projects = projects.map((project: any) => {
          if (project.id === fromProject.id) {
            return fromProject;
          }
          return project;
        });
      }

      return state.set('projects', projects);
    }

    case projectsActions.SET_FOLDER_TARGET:
      return state.set('folderTarget', action.payload.target);

    case projectsActions.SET_SETTINGS_TARGET:
      return state.set('settingsTarget', action.payload.target);

    case projectsActions.SET_APPLICATION_STATUS_TARGET:
      return state.set('applicationStatusTarget', action.payload.target);

    case hiringConfirmationActions.HIRING_ANSWER_SUBMITTED: {
      if (!state.get('projects')) return state;
      const answer: JobFeedbackAnswer = action.payload.answer;
      return state.set(
        'projects',
        state.get('projects').map((project: any) => {
          if (!project.jobs?.some((job: any) => job.id === answer.jobId)) return project;
          return {
            ...project,
            jobs: project.jobs.map((job: any) =>
              job.id === answer.jobId
                ? {
                    ...job,
                    didYouHireFeedback: false,
                    hiringOutcome: {
                      ...job.hiringOutcome,
                      action: answer.action,
                      reason: answer.reason ?? null,
                      reasonText: answer.reasonText ?? null,
                    },
                    hiredApplications: answer.hiredApplications,
                  }
                : job
            ),
          };
        })
      );
    }

    case teamActions.MUTATE_REVOKE_DONE:
    case teamActions.MUTATE_GRANT_DONE: {
      let newState = state;

      /** if on project list update there */
      if (state.get('projects')) {
        newState = newState.set(
          'projects',
          // @ts-ignore
          state.get('projects').map((project: any) => {
            const newproject = project;
            if (project.id === action.payload.id) {
              newproject.access = action.payload.access;
            }
            return newproject;
          })
        );
      }
      return newState;
    }

    case 'LOGOUT':
      return initState;
    default:
      return state;
  }
}
